/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Product.Giftbox.Headline';
